module.exports = __webpack_public_path__ + "static/img/xygt.1ee4b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xygt.png
// module id = dVzh
// module chunks = 1